import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import "./styles/index.scss";
import AppHeader from '@/components/layouts/AppHeader.vue';
import AppSider from '@/components/layouts/AppSider.vue';
// 增加的引入
import 'element-plus/dist/index.css'
import UserService from "@/api/user";
import PasswordService from "@/api/password";
import LoggerService from "@/api/logger";
import CategoryService from "@/api/category";
import SecurityService from "@/api/security";
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import NativeService from "@/api/native";

const app = createApp(App);
app.component('AppHeader', AppHeader);
app.component('AppSider', AppSider);
app.provide('userService',  new UserService());
app.provide('passwordService',  new PasswordService());
app.provide('loggerService',  new LoggerService());
app.provide('categoryService',  new CategoryService());
app.provide('securityService',  new SecurityService());
app.provide('nativeService',  new NativeService());
app.use(store).use(router).use(ElementPlus, {
    locale: zhCn,
}).mount('#app')
